import { UserRepository } from "../../../api";
import { Report } from "./Report";

export class ComunicationReport extends Report {

	constructor(obj = {}) {
		super();

		this.engagementPoints 	= obj.engagementPoints || {};
		this.comunicationPoints = obj.comunicationPoints || {};
		this.active = false;
	
		this.setColors();
		this.setPoints();
		this.setLabels();

	}

	setColors() {

		const engagementArray 	= Object.keys(this.engagementPoints) ;
		const comunicationArray 		= Object.keys(this.comunicationPoints) ;

		const engagementColors = engagementArray.map(i => {
			return this.getColor(this.engagementPoints[i]);
		});

		const comunicationColors = comunicationArray.map(i => {
			return this.getColor(this.comunicationPoints[i]);
		});

		this.colors = this.compilateArray({engagementColors, comunicationColors});
	}

	setPoints() {

		const engagementArray 	= Object.keys(this.engagementPoints) ;
		const comunicationArray 		= Object.keys(this.comunicationPoints) ;

		const engagementPoints = engagementArray.map(i => {
			return this.getPoints(this.engagementPoints[i]);
		});

		const comunicationPoints = comunicationArray.map(i => {
			return this.getPoints(this.comunicationPoints[i]);
		});

		this.points = this.compilateArray({engagementPoints, comunicationPoints});
	}

	setLabels() {
		const engagementArray 	= Object.keys(this.engagementPoints);
		const comunicationArray = Object.keys(this.comunicationPoints);

		const allItems = this.compilateArray({engagementArray, comunicationArray});

		this.labels = allItems.map(i => {
			switch(i) {
				case "3-1" : return "Envolvimento com comunidades locais";
				case "3-2" : return "Conscientização dos colaboradores";
				case "3-3" : return "Gestão de compras";
				case "3-4" : return "Informação aos clientes";
				case "3-5" : return "Canais de comunicação";
			}
		});
	}

	generateChart(id) {
		this.generateReport(id, this.colors, this.points, this.labels);
	}

	init(auth, id) {
		return {
			colors: this.colors,
			points: this.points,
			labels: this.labels,
			active: false
		};
	}
}


// WEBPACK FOOTER //
// src/models/lib/entities/ComunicationReport.js